<script lang="ts">
	type RadioOptions = Array<{
		value: string | number
		title: string
		color?: string
	}>

	type ValueType = string | number

	interface Props {
		value: ValueType
		name: string
		options: RadioOptions
		onChange: (val: ValueType) => void
	}

	let { value, name, options, onChange }: Props = $props()

	function onValueUpdate(val: string | number) {
		value = val
		onChange(value)
	}
</script>

<div class="RadioSelector">
	{#each options as { value: val, title, color }}
		<div class="radio-input-container" style="--color-radio: {color};">
			<input type="radio" id="{name}-{val}" value={val} {name} oninput={() => onValueUpdate(val)} />
			<label for="{name}-{val}">{title}</label>
		</div>
	{/each}
</div>

<style>
	.RadioSelector {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.radio-input-container {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.5rem;
		cursor: pointer;
	}

	input {
		height: 0.5rem;
		width: 0.5rem;
		padding: 0;
		border: 1px solid var(--color-border);
	}

	input:checked {
		background-color: var(--color-radio, var(--color-text-light));
	}
</style>
